import React from "react";
import {FormattedMessage, FormattedNumber} from "react-intl";

export const achievementPointsFormatter = (detail, isScheduledGame) => {
    if (!detail) {
        return null;
    }
    if (detail.times != detail.points) {
        return <span><FormattedNumber value={detail.times}/>{` (${detail.points})`}</span>;
    }
    return detail.points
};

const TeamAchievementDetail = ({detail, achievement, isScheduledGame = false}) => {
    return <tr>
        <td>{achievement.name || achievement.achievement}</td>
        <td>{achievementPointsFormatter(detail, isScheduledGame)}</td>
    </tr>
};


const SideDetailsHeadToHead = ({achievements, details, isScheduledGame = false}) => {
    let total = details.reduce((carry, e) => carry + e.points, 0);

    return <table className="zw-tbl tbl-bordered tbl-game-details" style={{ width: isScheduledGame && '100%' }}>
        <thead>
        <tr>
            <th><FormattedMessage id="generic.statistic"/></th>
            <th className="results-th"><FormattedMessage id="generic.result"/></th>
        </tr>
        </thead>
        <tbody>
        {achievements.map(
            achievement => <TeamAchievementDetail
                key={achievement.id} achievement={achievement}
                detail={details.find(d => d.achievement.id === achievement.id)} isScheduledGame={isScheduledGame}/>)}
        </tbody>
        <tbody>
        <tr>
            <td className="total-td" />
            <td className="total-td">{total}</td>
        </tr>
        </tbody>
    </table>
};

export default SideDetailsHeadToHead;